import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Platform } from '@ionic/angular';
import { appConfig } from 'src/app/config/app.config';
import { Employee } from 'src/app/models/Employees';
import { Relative } from 'src/app/models/Relative';
import { AuthService } from 'src/app/services/auth.service';
import { ContactsService } from 'src/app/services/contacts.service';
import { JsonService } from 'src/app/services/json.service';
import { EmployeeSService } from 'src/app/services/modelService/employeeS.service';
import { RelativeService } from 'src/app/services/modelService/relative.service';
import { TranslateService } from 'src/app/services/translate.service';
import { AlertService } from 'src/app/util/alert.service';
import { ToastService } from 'src/app/util/toast.service';
import { UtilityService } from 'src/app/util/utility.service';
import { CountryService } from 'src/app/services/country.service';

@Component({
  selector: 'app-user-edit-component',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss'],
})
export class UserEditComponent implements OnInit {
  isLive: boolean = true;
  utilityService: UtilityService = new UtilityService();
  dob: string;
  minDate: string;
  maxDate: string;
  objectKeys = Object.keys;


  @Input() emp: Employee = new Employee();
  @Output() mobileBlur = new EventEmitter<string>();

  constructor(private empService: EmployeeSService,
    private alert: AlertService,
    private contactsService: ContactsService, public trans: TranslateService,
    private relativeService: RelativeService, public auth: AuthService,
    public toastService: ToastService, public platform: Platform,
    public countryService: CountryService) {
    this.trans.translateObjList(this.utilityService.educationObjectList);
  }

  ngOnInit() {
    const currentDate = new Date();
    this.maxDate = currentDate.toISOString().split('T')[0];
    this.updateDateLimits()

    if (this.emp?.user?.user_pd?.mobile && this.emp.user.user_pd.mobile.startsWith('+')) {
      const parsed = this.countryService.parsePhone(this.emp.user.user_pd.mobile);
      if (parsed) {
        this.emp.user.user_pd.country_code = parsed.countryCode;
        this.emp.user.user_pd.mobile = parsed.number;
      }
    } else if (this.emp?.user?.user_pd && !this.emp.user.user_pd.country_code) {
      this.emp.user.user_pd.country_code = '+91'; // Default
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['emp'] && changes['emp'].currentValue) {
      this.updateDateLimits();
    }
  }
  updateDateLimits() {
    if (this.emp && this.emp.user.dob) {
      const dobDate = new Date(this.emp.user.dob);
      this.minDate = dobDate.toISOString().split('T')[0];
    } else {
      this.minDate = '';
    }
    if (this.emp.user.user_pd.death_date) {
      this.isLive = false;
    }
    console.log(this.minDate, " ...", this.maxDate)
  }
  afterUpload(url) {
    console.log(url);
    this.emp.user.url = url;
    this.empService.saveUser(appConfig.STORAGE_TABLE.USER, this.emp.user).then(() => {
      this.relativeService.getRelative(this.emp.id, "relative_id").then(async (relativeList: Relative[]) => {
        for (let relative of relativeList) {
          relative.url = url;
        }
        await this.relativeService.saveObjectList(relativeList);

      })
    })
  }

  onClickContact() {

    this.contactsService.getContacts().then(async (cont: any) => {
      if (cont && cont.length > 0) {
        // this.toastService.warning(JSON.stringify(cont));
        if (cont[0].tel.length > 0) {
          this.emp.user.user_pd.mobile = cont[0].tel[0].replaceAll(" ", "").replace("-", "").slice(-10);
        }
        let nameArray = cont[0].name[0].split(" ");
        this.emp.user.name = nameArray[0];
      }
    })
  }
  assumeDate() {
    if (!this.emp.user.dob) {
      if (this.emp.user.user_pd.marital == 'Married') {
        this.emp.user.dob = new Date(new Date().getTime() - (35 * 31556926000));
      } else {
        this.emp.user.dob = new Date(new Date().getTime() - (15 * 31556926000));
      }
    }
  }

  onBlurMobile() {
    if (!this.emp?.user?.user_pd?.mobile || this.emp.user.user_pd.mobile.trim().length === 0) {
      this.emp.user.user_pd.mobile = null;
    }
    if (this.emp?.user?.user_pd?.mobile) {
      this.mobileBlur.emit(this.emp.user.user_pd.mobile);
    }
  }

  clickAddAchievements(item) {
    if (!item) {
      item = {};
    }
    this.alert.show2TextAlert("Achievement / Post", "Tell us about your achievements or roles — share your field and rank/designation to inspire others!", "Field", "Position", "Add", "Cancel", Object.keys(item)[0], item[Object.keys(item)[0]]).then((data) => {
      if (data.length == 2) {
        if (!this.emp.user.user_pd.achievement) {
          this.emp.user.user_pd.achievement = [];
        }
        if (Object.keys(item).length == 0) {
          this.emp.user.user_pd.achievement.push({ [data[0]]: data[1] });
        } else {
          item[Object.keys(item)[0]] = data[1];
        }

      } else {
        this.toastService.warning("Please enter both field and position");
      }
    })
  }
  deleteAchievement(item) {
    this.alert.showAlert("Delete", "Are you sure you want to delete this item?", "Yes", "Cancel").then((data) => {
      this.emp.user.user_pd.achievement.splice(this.emp.user.user_pd.achievement.indexOf(item), 1);
    })
  }

  onIsLiveChange(isLive: boolean) {
    if (isLive) {
      this.emp.user.user_pd.death_date = null;
    }
  }
  onPrivacyChange(event) {
    console.log(event);
    this.emp.user.user_pd.privacy = event
  }
}
